module.exports = __webpack_public_path__ + "img/02-8销售运营管理.df6e175c.png";